<nz-layout class="height-full">
    <nz-header
        class="am-dash-navbar"
        [ngClass]="{ 'dev-mode': isDevMode }"
        *ngIf="signedIn$ | async"
    >
        <div style="display: flex; width: 100%">
            <div><app-navbar></app-navbar></div>
            <div style="flex-grow: 1"></div>
            <div><app-env-switcher></app-env-switcher></div>
        </div>
    </nz-header>
    <div class="height-full min-height-0">
        <router-outlet></router-outlet>
    </div>
</nz-layout>

<div class="extras">
    <app-version></app-version>
    <ng-container *ngIf="isSignedIn">
        <a class="extra" [routerLink]="['jobs', 'summary']">Jobs</a>
        <a class="extra" (click)="signOut()">Logout</a>
    </ng-container>
</div>
